export const NotFound = () => {
  return <div>Sorry, we couldn&apos;t find that page.</div>;
};
